import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { saveAffiliateReferrer } from "../utils/affiliateReferrer";

const AFFILIATE_QUERY_KEY = "affiliate";

export const useAffiliateCapture = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        const params = new URLSearchParams(location.search);
        const affiliate = params.get(AFFILIATE_QUERY_KEY);

        if (affiliate) {
            saveAffiliateReferrer(affiliate);
        }
    }, [location.search]);
};


